import { render, staticRenderFns } from "./item.vue?vue&type=template&id=3780c895&scoped=true"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"
import style0 from "./item.vue?vue&type=style&index=0&id=3780c895&prod&lang=scss"
import style1 from "./item.vue?vue&type=style&index=1&id=3780c895&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3780c895",
  null
  
)

export default component.exports